import { render } from "./NftSubmitCard.vue?vue&type=template&id=700c8005&scoped=true"
import script from "./NftSubmitCard.vue?vue&type=script&lang=js"
export * from "./NftSubmitCard.vue?vue&type=script&lang=js"

import "@/Common/Styles/nftSubmitCard.scss?vue&type=style&index=0&id=700c8005&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/THEOS-interfaces/THEOS-interfaces/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-700c8005"]])

export default __exports__